import React from 'react'
import { PaymentSummaryType } from '../types'
import CircularProgressBar from 'components/circularProgressBar/CircularProgressBar'
import { numberFormatter } from 'helpers'
import { colors } from 'styles/colors'
import { NotAvailableIcon } from 'assets'

export const PotentialClientProgress = ({
    paymentSummary: { balance }
}: {
    paymentSummary: PaymentSummaryType
}) => {
    if (balance === 0) {
        return (
            <div className="client-payment--progress-container">
                <div
                    aria-label="progress-not-available"
                    className="client-payment--progress-bar-not-available"
                >
                    <NotAvailableIcon width="84" height="84" />
                </div>
            </div>
        )
    }

    if (balance < 0) {
        return (
            <div
                className="client-payment--progress-container"
                aria-label="potential-client-progress"
            >
                <CircularProgressBar
                    percentage={100}
                    centerLabel={numberFormatter(balance, '').trim()}
                    gaugeColor={colors.red}
                />
            </div>
        )
    }
    return (
        <div
            className="client-payment--progress-container"
            aria-label="potential-client-progress"
        >
            <CircularProgressBar
                percentage={100}
                centerLabel={numberFormatter(balance, '')}
                gaugeColor={colors.maroon}
            />
        </div>
    )
}
